import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=6b10019f&scoped=true&lang=pug&"
import script from "./Banks.vue?vue&type=script&lang=js&"
export * from "./Banks.vue?vue&type=script&lang=js&"
import style0 from "./Banks.vue?vue&type=style&index=0&id=6b10019f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10019f",
  null
  
)

export default component.exports